import { productAvailabilityStyles as styles } from "@insite/content-library/Components/ProductAvailability";
import { IconWrapper } from "@insite/mobius/Icon";
import getColor from "@insite/mobius/utilities/getColor";
import { commonInputIcons, commonLinkStyles, customLinkHoverStyles } from "@solveindustrial/Utilities/styleguide";
import { colorStrings, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.messageGridItem = {
    ...styles.messageGridItem,
    css: css`
        ${styles.messageGridItem?.css}

        & div {
            background-color: transparent;
            padding: 5px 0;

            & ${IconWrapper} {
                width: 16px;
                height: 16px;
                border-radius: 50%;
                color: ${getColor(colorStrings.commonGlobalWhite)};
                margin-right: 5px;

                svg {
                    width: 20px;
                    height: 12px;
                }
            }

            &[color="success"] {
                color: ${getColor(colorStrings.successMain)};
                & ${IconWrapper} {
                    background-color: ${getColor(colorStrings.successMain)};
                }
            }

            &[color="warning"] {
                color: ${getColor(colorStrings.warningMain)};
                & ${IconWrapper} {
                    background-color: ${getColor(colorStrings.warningMain)};
                }
            }

            &[color="danger"] {
                color: ${getColor(colorStrings.dangerMain)};

                & ${IconWrapper} {
                    background-color: ${getColor(colorStrings.dangerMain)};
                }
            }
        }
    `,
};

styles.messageText = {
    ...styles.messageText,
    css: css`
        ${styles.messageText?.css}
        font-size: 14px;
        line-height: 20px;

        ${mediaQueriesBP.minMD} {
            font-size: 16px;
            line-height: 29px;
        }
    `,
    mergeCss: true,
};

styles.availabilityByWarehouseLink = {
    ...styles.availabilityByWarehouseLink,
    css: css`
        ${styles.availabilityByWarehouseLink?.css}
        ${commonLinkStyles}
        ${customLinkHoverStyles}
        font-size: 14px;
        line-height: 20px;

        ${mediaQueriesBP.minMD} {
            font-size: 16px;
            line-height: 29px;
        }
    `,
    mergeCss: true,
};

styles.availabilityByWarehouseModal = {
    ...styles.availabilityByWarehouseModal,
    sizeVariant: "medium",
    size: 600,
    cssOverrides: {
        modalContent: css`
            padding: 24px;
        `,
    },
};

// styles.availabilityByWarehouseTable = {
//     ...styles.availabilityByWarehouseTable,
//     css: css`
//         ${styles.availabilityByWarehouseTable?.css}
//         width: 85%;
//         margin: 24px auto;
//     `,
//     mergeCss: true,
// };

styles.availabilityByWarehouseTableCell = {
    ...styles.availabilityByWarehouseTableCell,
    css: css`
        ${styles.availabilityByWarehouseTableCell?.css}

        &[data-test-selector="warehouseAvailabilityModal_TotalDescription"] span,
        &[data-test-selector="warehouseAvailabilityModal_TotalQuantity"] {
            font-weight: 700;
        }
    `,
};
    
